// @flow
/** @jsx h */

import { h, Component } from 'preact'

import styles from './Button.css'
import { bem } from '../../helpers/bem'
import { themeToClassName } from '../../helpers/themeToClassName'

type Props = {
  className?: string,
  onClick: () => void,
  children?: ?any
}

export class Button extends Component<Props> {
  render () {
    const { theme } = this.context

    const classes = [
      'nrk-button',
      bem(styles.button, themeToClassName(theme)),
      this.props.className || ''
    ].join(' ')

    return (
      <button className={classes} onClick={this.props.onClick}>
        {this.props.children}
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Button/Button.js